export default __webpack_public_path__ + "static/media/shipped.a12062bc.svg";